/**
 * Season tooltips utilities
 * Provides season descriptions based on territory domain
 */

import seasonsTooltips from '../../data/texts/seasons-tooltips.json' with { type: 'json' };

/**
 * Get tooltip text for a season based on territory domain
 * @param {string} seasonName - Name of the season (e.g., "Hiver", "Printemps", "Saison des pluies")
 * @param {string|undefined} domain - Territory domain (e.g., "Guyane", "Réunion", undefined for France hexagonale)
 * @returns {string|null} Tooltip text describing the months or null if not found
 *
 * @example
 * getSeasonTooltip("Hiver", undefined) // => "De décembre à février"
 * getSeasonTooltip("Saison des pluies", "Réunion") // => "De janvier à mars"
 * getSeasonTooltip("Été", "Guyane") // => null (not defined for Guyane)
 */
const getSeasonTooltip = (seasonName, domain) => {
  // Use 'default' for France hexagonale (when domain is undefined)
  const domainKey = domain || 'default';
  
  // Lookup tooltip in the configuration
  const domainSeasons = seasonsTooltips[domainKey];
  if (!domainSeasons) {
    return null;
  }
  
  return domainSeasons[seasonName] || null;
};

export default getSeasonTooltip;
